import React, { useState } from "react";
import { AiOutlineRight } from "react-icons/ai";
import tpsText from "../../utils-component/tpsText";

export default function KnowledgeUpdate() {
  const [email, setEmail] = useState("");

  return (
    <div className="container">
      <div className="border-2 relative mt-10 md:my-14 flex flex-col md:flex-row space-y-4 md:space-x-10 border-blue-100 p-5 xs:p-10 rounded md:justify-between">
        <div className="space-y-5 flex-1 text-left my-12">
          <p className="text-black text-3xl font-bold">Keep up to date</p>
          <p className="text-black text-lg">
            Join the {tpsText()} mailing list for the very latest industry news, offers
            and IT expertise.
          </p>
        </div>

        <div className="flex items-center md:px-0 md:flex-row mb-10 space-x-3">
          <input
            type="text"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 py-3 px-4  placeholder:text-black rounded-full bg-gray-200 text-black outline-primary100"
          />
          <div
            className="rounded-full p-3 border-2 cursor-pointer border-primary100"
            onClick={() => setEmail("")}
          >
            <AiOutlineRight />
          </div>
        </div>
      </div>
    </div>
  );
}
